import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { MdRequestPage } from 'react-icons/md';
import AcademiaButton from '../CommonComps/Buttons/AcademiaButton';
import CreateEditVacationRequestModal from '../CommonComps/Modals/CreateEditVacationRequestModal';

const CreateVacationRequestAction = () => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering create vacation request action component here
  return (
    <div className='flex items-center justify-end'>
      <AcademiaButton
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<MdRequestPage className='size-6' />}
      >
        Request Vacation
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditVacationRequestModal
            title='create'
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateVacationRequestAction;
